'use client';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { DismissFilled } from '@fluentui/react-icons';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { FormProvider, useForm } from 'react-hook-form';
import { ProjectForm } from '@ui/components/Forms/ProjectForm';
import { toast } from 'react-toastify';
import { uploadFileAction } from '@application/redux/actions/fileActions';
import { ProjectApi } from '@application/api/endpoints/project-api';
const ProjectDialog = ({ isOpen, onClose, variant = 'add', selectedProject, setRefresh, setSelectedProject }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const pathname = window.location.pathname;
    const segments = pathname.split('/');
    const [selectedFile, setSelectedFile] = useState(null);
    const methods = useForm({
        defaultValues: {
            projectName: '',
            startDate: null,
            endDate: null,
            description: '',
            logoUrl: '',
            id: ''
        },
        mode: 'onBlur'
    });
    const handleClose = () => {
        onClose();
        methods.reset();
    };
    const onSubmit = async (formData) => {
        try {
            if (selectedFile && selectedFile.name) {
                var fileResponse = await dispatch(uploadFileAction('ProjectLogo', selectedFile));
                if (fileResponse) {
                    const { blob } = fileResponse;
                    formData.logoUrl = selectedFile.name || '';
                    formData.imageName = blob.name;
                }
            }
            var response = selectedProject?.id
                ? await ProjectApi.updateProject(selectedProject.id, formData)
                : await ProjectApi.createProject(formData);
            if (response.data && response.isSuccess) {
                toast.success(response.message);
                setRefresh(true);
            }
            else {
                toast.error(response?.message);
            }
        }
        catch (error) {
            toast.error(t('FailedNotesError'));
        }
        finally {
            handleClose();
        }
    };
    useEffect(() => {
        if (selectedProject) {
            methods.reset(selectedProject);
        }
    }, [selectedProject]);
    return (_jsxs(Dialog, { open: isOpen, onClose: handleClose, maxWidth: 'sm', PaperProps: {
            sx: {
                width: '564px'
            }
        }, fullWidth: true, "aria-labelledby": 'ProjectDialog', onKeyDown: (e) => e.key === 'Enter' && methods.handleSubmit(onSubmit)(), children: [_jsxs(DialogTitle, { id: 'project-dialog', sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }, children: [_jsxs(Typography, { variant: 'h6', color: 'text.primary', children: [variant === 'add' ? 'Create' : 'Edit', " Project"] }), _jsx(IconButton, { onClick: handleClose, children: _jsx(DismissFilled, { fontSize: 18 }) })] }), _jsx(Divider, {}), _jsx(DialogContent, { children: _jsx(Box, { className: 'form-wrapper', sx: { mt: 1 }, children: _jsx(FormProvider, { ...methods, children: _jsx(ProjectForm, { setSelectedFile: setSelectedFile, project: selectedProject, setProject: setSelectedProject }) }) }) }), _jsx(Divider, {}), _jsxs(DialogActions, { sx: { p: 3 }, children: [_jsx(Button, { onClick: methods.handleSubmit(onSubmit), variant: 'contained', color: 'primary', sx: {
                            bgcolor: '#1e293b',
                            '&:hover': { bgcolor: '#334155' },
                            borderRadius: '4px'
                        }, children: t('Confirm') }), _jsx(Button, { onClick: handleClose, variant: 'outlined', color: 'inherit', sx: { borderRadius: '4px' }, children: t('Cancel') })] })] }));
};
export default ProjectDialog;
